import React, { FC, useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Tag } from 'components/atoms/tag';
import { Filter } from 'components/molecules/filters/types';
import { FilterCriteriaAsText } from 'components/organisms/dashboard/filter-as-text';
import { getRandomColor } from 'utils/get-random-color';
import { BadgeWrapper, TagWrapper } from './styles';

const maxVisibleFilters = 3;

export const FilterDrawerBadges: FC<{
  filter: Filter;
  showMinimumBadges?: boolean;
}> = ({ filter: _filter, showMinimumBadges }) => {
  const divRef = useRef({} as HTMLDivElement);
  const [hovered, setHovered] = useState(false);

  // Ref: https://github.com/facebook/react/issues/4492#issuecomment-569410248
  useEffect(() => {
    if (
      hovered &&
      divRef.current &&
      divRef.current?.matches(':hover') === false
    ) {
      setHovered(false);
    }
  }, [hovered]);

  const { criteria } = _filter;
  const renderCriteria = showMinimumBadges
    ? criteria.slice(0, maxVisibleFilters)
    : criteria;

  const countBadgeColor = getRandomColor(maxVisibleFilters);

  return (
    <BadgeWrapper
      ref={divRef}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {renderCriteria.map((fieldFilter) => {
        const color = getRandomColor(Math.abs(fieldFilter.field.fieldId));

        return (
          <TagWrapper key={fieldFilter.field.fieldId}>
            <Tag color={color}>
              <FilterCriteriaAsText criterion={fieldFilter} />
            </Tag>
          </TagWrapper>
        );
      })}
      {showMinimumBadges && criteria.length > maxVisibleFilters ? (
        <TagWrapper>
          <Tag color={countBadgeColor}>
            <FormattedMessage
              id="templates.status_updates.tab.config.publish.projects.filtered.more"
              values={{
                count: criteria.length - maxVisibleFilters,
              }}
            />
          </Tag>
        </TagWrapper>
      ) : null}
    </BadgeWrapper>
  );
};
